import { render, staticRenderFns } from "./PurchaseQuotationList.vue?vue&type=template&id=8a4d5a02&scoped=true"
import script from "./PurchaseQuotationList.vue?vue&type=script&lang=js"
export * from "./PurchaseQuotationList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseQuotationList.vue?vue&type=style&index=0&id=8a4d5a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4d5a02",
  null
  
)

export default component.exports